import React, { useState, useEffect } from 'react'
import { apiBase } from '../../services/apiBase'
import { api } from '../../utils/api'
import { Box, Typography, Paper, List, ListItem, ListItemText, Divider, IconButton } from '@mui/material'
import UserLayout from '../../layouts/UserLayout'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useNavigate } from 'react-router-dom'

const ZaloStatistics = () => {
	const navigate = useNavigate()
	const [statistics, setStatistics] = useState({
		totalPoints: 0,
		referral: 0,
		buy: 0,
		refund: 0,
		used: 0,
		difference: 0,
	})

	const fetchStatistics = async () => {
		try {
			const response = await apiBase.get(api.GET_ALL_POINT)

			const totalPoints = response.tongdiem[0]?.totalAmount || 0

			const pointsByType = {}
			response.sumPointAction.forEach((item) => {
				pointsByType[item._id] = item.totalAmount
			})

			const difference =
				totalPoints +
				(pointsByType.useScore || 0) -
				(pointsByType.buy || 0) -
				(pointsByType.refund || 0) -
				(pointsByType.referral || 0)

			setStatistics({
				totalPoints: totalPoints,
				referral: pointsByType.referral || 0,
				buy: pointsByType.buy || 0,
				refund: pointsByType.refund || 0,
				used: pointsByType.useScore || 0,
				difference: difference,
			})
		} catch (error) {
			console.error('Error fetching statistics:', error)
		}
	}

	useEffect(() => {
		fetchStatistics()
	}, [])

	return (
		<UserLayout>
			<Box sx={{ bgcolor: '#fff', minHeight: '100vh', maxWidth: '992px', margin: '0 auto' }}>
				{/* Header */}
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: 2,
						p: 2,
						background: '#fff',
						borderBottom: '1px solid #e0e0e0',
						position: 'sticky',
						top: 0,
						zIndex: 1000,
					}}>
					<IconButton onClick={() => navigate(-1)}>
						<ArrowBackIcon />
					</IconButton>
					<Typography variant='h6' sx={{ ml: 1, textAlign: 'left' }}>
						Thống kê
					</Typography>
				</Box>

				<Box sx={{ mt: 2 }}>
					<Paper elevation={2}>
						<List>
							<ListItem>
								<ListItemText
									primary='Tổng điểm'
									secondary={statistics.totalPoints}
									primaryTypographyProps={{ variant: 'subtitle1' }}
									secondaryTypographyProps={{
										variant: 'h6',
										color: 'primary',
									}}
								/>
							</ListItem>
							<Divider />

							<ListItem>
								<ListItemText primary='Giới thiệu' secondary={statistics.referral} />
							</ListItem>
							<Divider />

							<ListItem>
								<ListItemText primary='Mua hàng' secondary={statistics.buy} />
							</ListItem>
							<Divider />

							<ListItem>
								<ListItemText primary='Điểm hoàn trả' secondary={statistics.refund} />
							</ListItem>
							<Divider />

							<ListItem>
								<ListItemText primary='Điểm đã sử dụng' secondary={statistics.used} />
							</ListItem>
							<Divider />

							<ListItem>
								<ListItemText
									primary='Chênh lệch'
									secondary={statistics.difference}
									primaryTypographyProps={{ variant: 'subtitle1' }}
									secondaryTypographyProps={{
										variant: 'h6',
										color: statistics.difference > 100 ? 'error' : 'success.main',
									}}
								/>
							</ListItem>
						</List>
					</Paper>
				</Box>
			</Box>
		</UserLayout>
	)
}

export default ZaloStatistics
